export default "__VITE_ASSET__da6e5eb1__"